exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bar-component{border:1px dashed red}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./src/styles/nav/Bar.css
 ** module id = 109
 ** module chunks = 0
 **/